<template>
  <div
    v-if="labelText.length"
    :class="[
      'lot-card__status-bid',
      {
        good: userBid && isUserBidLeading,
        warning: userBid && !isUserBidLeading
      }
    ]">
    <div class="label">
      <span>{{ labelText }}</span>
    </div>

    <div v-if="userBid" :class="['value', { 'animation-process': isChangeBid }]">
      {{ format_currency(userBid) }}
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref, computed, watch, onMounted, onUnmounted } from "vue";
  import { trans } from "@/utils/trans";
  import { format_currency } from "@/utils/currencies";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { ILot } from "@/models";
  import { LotSoldStatuses } from "@/enum";

  const props = defineProps({
    hiddenPendingProp: {
      type: Boolean,
      default: false
    }
  });

  const messages = {
    pending: trans("live.catalog.bid_statuses.pending"),
    leading: trans("live.catalog.bid_statuses.leading"),
    outbid: trans("live.catalog.bid_statuses.outbid"),
    won: trans("live.catalog.bid_statuses.won")
  };

  const auctionStore = useAuctionStore();
  const popupLot = computed(() => auctionStore.popupLot as ILot);
  const userBid = computed(() => auctionStore.popupLot?.user_bid ?? 0);
  const isUserBidLeading = computed(() => popupLot?.value.leader_id === auctionStore.user?.id);

  const isChangeBid = ref(false);

  const labelText = computed(() => {
    if (popupLot.value.sold_status === LotSoldStatuses.SOLD) {
      if (userBid.value) {
        return isUserBidLeading.value ? messages.won : messages.outbid;
      }
      return "";
    } else {
      if (userBid.value) {
        return isUserBidLeading.value ? messages.leading : messages.outbid;
      }
      return props.hiddenPendingProp ? "" : messages.pending;
    }
  });

  watch(
    () => userBid.value,
    () => {
      setTimeout(() => {
        isChangeBid.value = true;
        setTimeout(() => {
          isChangeBid.value = false;
        }, 250);
      }, 300);
    }
  );

  watch(
    () => isUserBidLeading.value,
    (newValue, oldValue) => {
      if (newValue !== oldValue && !isChangeBid.value) {
        setTimeout(() => {
          isChangeBid.value = true;
          setTimeout(() => {
            isChangeBid.value = false;
          }, 250);
        }, 300);
      }
    }
  );
</script>
